import DocumentBasedService from "./DocumentBasedService";
let service = DocumentBasedService('automaticTranslationProgress')
export default {...service}
